import { UserSettingScreenCodeEnum } from '@/constant';
import { TUpdateFieldResponse } from '@/services';
import {
	CommonActions,
	TDataUpdateFieldsRequest,
	TValueUpdateFieldObjectNameEnum,
	useAppDispatch,
} from '@/stores';
import { useCallback } from 'react';

export const useUpdateFields = (
	defaultTableName?: TValueUpdateFieldObjectNameEnum,
	id?: string | number
) => {
	const dispatch = useAppDispatch();
	const handleUpdate = useCallback(
		({
			objectName,
			data,
			screenCode,
			callback,
		}: {
			objectName?: TValueUpdateFieldObjectNameEnum;
			data: TDataUpdateFieldsRequest['data'];
			screenCode?: UserSettingScreenCodeEnum;
			callback?(error?: any, fields?: TUpdateFieldResponse[]): void;
		}) => {
			if (defaultTableName && !id) {
				return;
			}

			if (!(objectName || defaultTableName)) {
				return;
			}

			dispatch(
				CommonActions.updateFieldsRequest({
					data: {
						objectName: (objectName ||
							defaultTableName) as TValueUpdateFieldObjectNameEnum,
						id: id || data?.id,
						data,
					},
					screenCode,
					callback,
				})
			);
		},
		[defaultTableName, id]
	);

	return { handleUpdate };
};
